import Component_PointerDrag_393dab533629edc18287d291c6035f9d from "../../../../content/examples/behaviors/pointer-drag/PointerDrag";
import Devtool_PointerDrag_393dab533629edc18287d291c6035f9d from "!!@devtool/loader!../../../../content/examples/behaviors/pointer-drag/PointerDrag";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_PointerDrag_393dab533629edc18287d291c6035f9d,
  Devtool_PointerDrag_393dab533629edc18287d291c6035f9d,
  DevTool,
  React
};